import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const QA = [
  { q: "Is LoyaltyCircle AI free?", a: "Yes. Joining and using the consumer app is 100% free, forever. We earn revenue from affiliate commissions, half of which we pay back to you as cashback." },
  { q: "How long does cashback take?", a: "Most cashback is approved within 30 days of your purchase, after the merchant confirms it isn't returned. Some retailers take up to 90 days." },
  { q: "Is the referral program an MLM?", a: "No. Referrals only earn from the platform's 50% share, only on verified purchases of the people you invite. There are no recruitment-only rewards and no deep multi-level chains." },
  { q: "Are credit card offers financial advice?", a: "No. Credit card recommendations are educational only and offers are subject to issuer approval. Always read the issuer's terms before applying." },
  { q: "Is my data private?", a: "Yes. We use your lifestyle profile to personalize deals, but never sell your personal data. You can delete your account anytime." },
  { q: "When can I cash out?", a: "Once you have at least $10 in approved balance, you can request a payout via bank, PayPal, or gift card. Stablecoin payouts are coming soon, where legally permitted." },
  { q: "What if a merchant doesn't track my purchase?", a: "Upload your receipt in the app. Our team and the merchant will review and credit your cashback if eligible." },
];

export default function FAQ() {
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-24">
      <div className="text-xs uppercase tracking-[0.2em] text-emerald-700 font-semibold mb-2">FAQ</div>
      <h1 className="font-display font-bold text-4xl lg:text-5xl tracking-tight text-gray-900">Frequently asked</h1>
      <p className="text-gray-700 mt-3">Everything about cashback, referrals, payouts, and compliance.</p>

      <div className="mt-10">
        <Accordion type="single" collapsible className="w-full">
          {QA.map((item, i) => (
            <AccordionItem key={i} value={`q-${i}`} className="border-b border-gray-200">
              <AccordionTrigger className="text-left text-base font-display font-semibold py-5 hover:no-underline">
                {item.q}
              </AccordionTrigger>
              <AccordionContent className="text-gray-600 leading-relaxed pb-5">
                {item.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>

      <div className="mt-16 rounded-2xl border border-gray-200 bg-white p-6 text-sm text-gray-600">
        <strong className="text-gray-900">Compliance:</strong> Cashback is subject to merchant
        confirmation, tracking accuracy, return windows, and affiliate network approval. Referral
        rewards are paid only on verified retail purchases — never for recruitment alone. Credit
        card offers are subject to issuer approval. Crypto/stablecoin payouts are not part of the
        MVP and may be offered later through licensed third-party providers where legally
        permitted. RewardCircle AI does not provide financial, tax, or legal advice.
      </div>
    </div>
  );
}
